export default {
  title: "Feriado de 07 de setembro - mudanças de itinerário",
  resume: "Durante o feriado de 07 de setembro (domingo) todas as linhas operadas pela Vinscol não passarão pelo centro Histórico.",
  img: "/news/neobus-44101.jpg",
  publishDate: "2025-08-30T00:00:00.000-03:00",
  content: [
    "No domingo, feriado de 07 de setembro todas as linhas operadas pela Vinscol não passarão pelo centro Histórico, em razão das comemorações e desfiles no Centro, seguindo viagem pela Av. Prefeito Victor Fantini e Av. Perimetral, sem entrar na Praça da Getúlio Vargas (Matriz), durante todo o dia, no sentido ida e volta.",
    "<>As linhas operadas pelo Consórcio Metropolitano <Link to={\"/company/4\"}>(Transporte Coletivo Metropolitano - MG)</Link> não são afetadas pelas comemorações de 7 de setembro.</>",
  ],
};
